import { HttpClient } from '../HttpClient';
/**
 * * Get Projects
 */

export const GetProjects = async ({ PageNumber = 1, RowsPerPage = 10, SortOrder = 'desc', SortColumn = 'updatedAt', SearchString, FilterBy, StatusIds = [], EmployeeId }) => {
  try {
    SearchString = encodeURIComponent(SearchString);
    const searchParams = {
      SearchString,
      FilterBy,
    };
    const { data } = await HttpClient.get('api/projects', {
      params: {
        PageNumber,
        RowsPerPage,
        SortOrder,
        SortColumn,
        ...(StatusIds != 0 ? { StatusIds } : null),
        ...(SearchString && SearchString !== undefined && FilterBy ? searchParams : null),
        ...(EmployeeId ? { EmployeeId } : null),
      },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
